module.exports = __webpack_public_path__ + "assets/img/title-0c1d90d9.png";